import queryString from 'query-string';
import axios from 'axios';
import { Answer } from '@/store/state';

const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/x-www-form-urlencoded'
}

export interface IRateArguments {
    answer: Answer;
    solution: string;
}

export interface IRateResult {
    success: boolean;
    rateId?: string;
    message?: string;
}

export const rate = (url: string, args: IRateArguments): Promise<IRateResult> => {
    if(process.env.NODE_ENV === 'production') {
        return axios.post<IRateResult>(url, queryString.stringify(args), {
            headers,
        })
        .then(response => response.data)
        .catch(rateError => {
            console.error({
                rateError
            })
            return {
                success: false,
                message: rateError,
                rateId: undefined
            }
        })
    } else {
        return new Promise(res => {
            setTimeout(() => {
                res({
                    success: true,
                    rateId: '1'
                })
            }, 1000);
        })
    }
}

export interface ICommentArguments {
    rateId: string;
    comment: string;
}

export interface ICommentResponse {
    success: boolean;
    message?: string;
}

export const comment = (url: string, args: ICommentArguments): Promise<ICommentResponse>  => {
    if(process.env.NODE_ENV === 'production') {
        return axios.post(url, queryString.stringify(args), {
            headers
        })
        .then(response => response.data)
        .catch(commentError => {
            console.error({
                commentError
            })
            return {
                success: false,
                message: commentError
            }
        })
    } else {
        return new Promise<ICommentResponse>(res => {
            setTimeout(() => {
                res({
                    success: true
                })
            }, 1000);
        })
    }
}
